import React from "react";
import "./PainterServiceSections.css";

const PainterGallery = ({ gallery }) => {
  return (
    <section className="pnt-gallery">
      <div className="pnt-container">
        <div className="pnt-section-head">
          <span className="pnt-tag">Our Work</span>
          <h2 className="pnt-heading">A Glimpse of Our Painting Projects</h2>
          <p className="pnt-subheading">
            Real projects completed by our painting experts across homes and businesses.
          </p>
        </div>

        <div className="pnt-gallery-bento">
          {gallery.map((item, index) => (
            <div className={`pnt-gallery-tile pnt-tile-${index + 1} pnt-fade`} key={index}>
              <img src={item.image} alt={item.title} loading="lazy" />
              <div className="pnt-gallery-caption">
                <span>{item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainterGallery;
